import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalForceUpdateComponent } from './modal-force-update.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalForceUpdateComponent],
  exports: [ModalForceUpdateComponent],
})
export class ModalForceUpdateModule {}
